import { UseMutateAsyncFunction, useMutation } from "@tanstack/react-query";
import { LOGIN } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { AxiosResponse } from "axios";
import { ILogin } from "@/types/apiResponse.types";
import { toast } from "react-toastify";
import { TLoginInitialData } from "@/types/apiParam.types";
import { apiRequestSendGe } from "@/utils/apiRequestSendGe";
import { useTranslations } from "next-intl";

export const useLoginRequest = (): UseMutateAsyncFunction<
  AxiosResponse<{ data: ILogin }>,
  Error,
  TLoginInitialData,
  unknown
> => {
  const t = useTranslations();

  const { mutateAsync: login } = useMutation({
    mutationFn: (data: TLoginInitialData) => apiRequest(LOGIN, "post", data),
    onError: () => {
      toast.error(t("invalid_credentials"), {
        position: "top-center",
      });
    },
  });
  return login;
};

export const useSendParcelLoginRequest = (): UseMutateAsyncFunction<
  AxiosResponse<{ data: ILogin }>,
  Error,
  TLoginInitialData,
  unknown
> => {
  const { mutateAsync: sendParcelLogin } = useMutation({
    mutationFn: (data: TLoginInitialData) =>
      apiRequestSendGe(LOGIN, "post", data),
    onError: () => {
      toast.error("Error occured", {
        position: "top-center",
      });
    },
  });
  return sendParcelLogin;
};
